import { render, staticRenderFns } from "./tagsView.vue?vue&type=template&id=254ec260&scoped=true"
import script from "./tagsView.vue?vue&type=script&lang=js"
export * from "./tagsView.vue?vue&type=script&lang=js"
import style0 from "./tagsView.vue?vue&type=style&index=0&id=254ec260&prod&rel=stylesheet%2Fless&lang=less&scoped=true"
import style1 from "./tagsView.vue?vue&type=style&index=1&id=254ec260&prod&rel=stylesheet%2Fscss&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254ec260",
  null
  
)

export default component.exports